(function () {
    const body = document.body;
  
    function resetButton(button) {
      button.removeAttribute('aria-busy');
      button.disabled = false;
      button.classList.remove('downloading');
    }
  
    function downloadSingleFile(url, filename) {
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || '';
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
  
    function handleZipDownload(e) {
      e.preventDefault();
      e.stopPropagation();
  
      const button = e.currentTarget;
      let fileData = button.dataset.download;
  
      if (!fileData) return;
  
      const zipName = (button.dataset.title || 'download') + '.zip';
  
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.classList.add('downloading');
  
      let files;
  
      try {
        files = JSON.parse(fileData);
      } catch {
        files = [fileData];
      }
  
      if (!Array.isArray(files)) files = [files];
  
      // Single file
      if (files.length === 1) {
        const filename =
          button.dataset.title ||
          files[0].split('/').pop().split('?')[0];
  
        downloadSingleFile(files[0], filename);
        resetButton(button);
        return;
      }
  
      // Multiple files → ZIP
      const zip = new JSZip();
  
      const fetches = files.map(url =>
        fetch(url)
          .then(res => {
            if (!res.ok) throw new Error('Fetch failed');
            return res.blob();
          })
          .then(blob => {
            const filename = url.split('/').pop().split('?')[0];
            zip.file(filename, blob);
          })
      );
  
      Promise.all(fetches)
        .then(() => zip.generateAsync({ type: 'blob' }))
        .then(zipBlob => {
          const blobUrl = URL.createObjectURL(zipBlob);
  
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = zipName;
  
          document.body.appendChild(a);
          a.click();
  
          a.remove();
          URL.revokeObjectURL(blobUrl);
        })
        .catch(() => {
          files.forEach(url => window.open(url, '_blank'));
        })
        .finally(() => {
          resetButton(button);
        });
    }
  
    function initZipDownloads(root = document) {
      root.querySelectorAll('[data-zip-download]').forEach(button => {
        if (button.dataset.downloadInit === 'true') return;
  
        button.addEventListener('click', handleZipDownload);
        button.dataset.downloadInit = 'true';
      });
    }
  
    document.addEventListener('DOMContentLoaded', () => {
      initZipDownloads();
    });
  
  })();